import { render, staticRenderFns } from "./CommonGrid2.vue?vue&type=template&id=88d17146"
import script from "./CommonGrid2.vue?vue&type=script&lang=js"
export * from "./CommonGrid2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88d17146')) {
      api.createRecord('88d17146', component.options)
    } else {
      api.reload('88d17146', component.options)
    }
    module.hot.accept("./CommonGrid2.vue?vue&type=template&id=88d17146", function () {
      api.rerender('88d17146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/CommonGrid2.vue"
export default component.exports